import { render } from "./YouPage.vue?vue&type=template&id=233000e1"
import script from "./YouPage.vue?vue&type=script&lang=js"
export * from "./YouPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__